'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var AllowedHubs = {
  HUBS_CAMPAIGN: 'HUBS_CAMPAIGN',
  HUBS_CTA: 'HUBS_CTA'
};

exports.default = AllowedHubs;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/signup-ui-core/static-1.15/js/constants/AllowedHubs.js
// module id = 141
// module chunks = 0